import { useTransition, animated } from 'react-spring'
import styled from 'styled-components'

import { TRANSITION_TIME_FAST_MS } from '../styles/mixins/constants'

type Props = {
  isVisible?: boolean
  isDark?: boolean
  onClose?: () => void
  children?: JSX.Element
  className?: string
  zIndexLayer?: number
}

export const TakeoverContainer = (props: Props): JSX.Element => {
  const { isVisible, children, isDark, className, zIndexLayer, onClose } = props
  const opacityTransition = useTransition(isVisible, {
    enter: {
      opacity: 1,
    },
    leave: {
      opacity: 0,
    },
    config: {
      duration: TRANSITION_TIME_FAST_MS,
    },
  })
  return (
    <Container className={className}>
      {opacityTransition((style, item, _, key) =>
        item ? (
          <Overlay style={style} key={key} onClick={onClose}>
            {children}
          </Overlay>
        ) : null
      )}
    </Container>
  )
}

const Container = styled.div``

const Overlay = styled(animated.div)`
  background-color: rgba(0, 0, 0, 0.9);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
`
